var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "10px",
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table/icon/sort/sm",
    transform: "translate(-0.016539, -0.034753)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon/arrow-button-down-2-copy",
    fill: "#8090A2",
    transform: "translate(4.034296, 2.069505) scale(1, -1) rotate(1.000000) translate(-4.034296, -2.069505) ",
    points: "8.03429559 0.0695953843 0.0342955935 0.0695050161 4.03413967 4.06950502"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon/arrow-button-down-2-copy-2",
    fill: "#C4CDD6",
    points: "8.01653858 6.03484288 0.0165385774 6.03475251 4.01638266 10.0347525"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort-ascending.2d90ce4721618da7cc6e6446cf0cf2fa.svg";
export { ForwardRef as ReactComponent };